import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IInternalLinkProps } from '../components/internal-link/internal-link';

export class InternalLinkModel extends ContentItem {
  get name(): string {
    return get(this._config, 'elements.internal_link_text.value', '');
  }

  get codename(): string {
    return get(this._config, 'system.codename', '');
  }

  get url(): string | null {
    return get(
      this._config,
      'elements.page.value[0].elements.basic_page_settings__url.value',
      null
    );
  }

  get extraClass(): string | null {
    const getValue = get(
      this._config,
      'elements.extraclass.value[0].codename',
      'none'
    );

    return getValue !== 'none' ? getValue : null;
  }

  public static create(data: IInternalLink): IInternalLinkProps {
    const { name, url, extraClass, codename } = new InternalLinkModel(data);
    return {
      name,
      url,
      extraClass,
      codename
    };
  }
}
